import useScrollToTop from "@/hooks/useScrollToTop"
import { cn } from "@/lib/utils"
import LogoImage from "@/novus/assets/images/hadley-logo.svg"
import React from "react"
import { Link } from "react-router-dom"
import { rootPath } from "../novus-paths"

type LayoutProps = { showLogo?: boolean; children?: React.ReactNode }
export function MainLayout({ showLogo = false, children }: LayoutProps) {
  useScrollToTop()

  return (
    <main
      className={cn("px-4 my-auto pt-24 pb-36 min-h-screen", "md:px-0")}
      style={{
        background:
          "radial-gradient(circle at 40% 500px, rgba(182, 163, 249, 0.5), white 600px)",
      }}
    >
      {showLogo ? (
        <div className="container justify-content-between w-10/12 md:w-8/12 mx-auto text-center mt-12 mb-12 md:my-[100px] pb-14 max-w-[650px] bg-white rounded-[40px]">
          <Link
            to={rootPath.pattern}
            className="inline-flex mx-auto bottom-7 md:bottom-12 relative"
          >
            <img src={LogoImage} alt="Hadley Logo" height={103} width={103} />
          </Link>
          {children}
        </div>
      ) : (
        children
      )}
    </main>
  )
}
